import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

// const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
//   subscription onEcritureLineCreated($companyId: ID!) {
//     ecritureLineCreated(companyId: $companyId) {
//       id
//       journal
//       amount
//       libelle
//       libelleExport
//       dateOperation
//       dateLettrage
//       labelLettrage
//       tiersClient {
//         id
//       }
//       project {
//         id
//         tiersClient {
//           id
//         }
//       }
//       article {
//         id
//       }
//       category {
//         id
//       }
//     }
//   }
// `;

// const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
//   subscription onEcritureLineUpdated($companyId: ID!) {
//     ecritureLineUpdated(companyId: $companyId) {
//       id
//       journal
//       amount
//       libelle
//       libelleExport
//       dateOperation
//       dateLettrage
//       labelLettrage
//       tiersClient {
//         id
//       }
//       project {
//         id
//         tiersClient {
//           id
//         }
//       }
//       article {
//         id
//       }
//       category {
//         id
//       }
//     }
//   }
// `;

// const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
//   subscription onEcritureLineDeleted($companyId: ID!) {
//     ecritureLineDeleted(companyId: $companyId) {
//       id
//       journal
//       amount
//       libelle
//       libelleExport
//       dateOperation
//       dateLettrage
//       labelLettrage
//       tiersClient {
//         id
//       }
//       project {
//         id
//         tiersClient {
//           id
//         }
//       }
//       article {
//         id
//       }
//       category {
//         id
//       }
//     }
//   }
// `;

// const LETTRAGE_DONE = gql`
//   subscription onEcritureLineLettrageDone($companyId: ID!) {
//     ecritureLineLettrageDone(companyId: $companyId) {
//       date
//     }
//   }
// `;

class PerformanceReportChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.startCursorArray = [];
  }
  componentDidUpdate() {
    const data = this.props.data && this.props.data.getReportSalesData;

    if (!!!data) {
      this.startCursorArray = [];
      return;
    }

    const pageInfo = data && data.pageInfo;

    const startCursor = pageInfo && pageInfo.startCursor;
    if (this.startCursorArray.includes(startCursor)) {
      console.log("124 - already in array:", startCursor);
      return;
    }
    this.startCursorArray.push(startCursor);

    if (pageInfo && pageInfo.hasNextPage) {
      this.props.onLoadMore(pageInfo.endCursor, "getReportSalesData");
    }
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];
    if (!this.props.data) return;

    // this.startCursorArray = [];
  }

  // ecritureLineCreated
  // this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
  //   document: ECRITURELINE_CREATED_SUBSCRIPTION,
  //   variables: {
  //     companyId: this.props.companyId
  //   },

  //   updateQuery: (prev, { subscriptionData }) => {
  //     this.props.refetch();

  //     if (!subscriptionData.data) {
  //       return prev;
  //     }
  //     return prev;
  //   }
  // });

  // // ecritureLineUpdated
  // this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
  //   document: ECRITURELINE_UPDATED_SUBSCRIPTION,
  //   variables: {
  //     companyId: this.props.companyId
  //   },

  //   updateQuery: (prev, { subscriptionData }) => {
  //     //this.props.refetch();

  //     if (!subscriptionData.data) {
  //       return prev;
  //     }
  //     return prev;
  //   }
  // });

  // ecritureLineDeleted
  //   this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
  //     document: ECRITURELINE_DELETED_SUBSCRIPTION,
  //     variables: {
  //       companyId: this.props.companyId
  //     },

  //     updateQuery: (prev, { subscriptionData }) => {
  //       this.props.refetch();

  //       if (!subscriptionData.data) {
  //         return prev;
  //       }
  //       return prev;
  //     }
  //   });

  //   // lettageDoneCreated
  //   this.unsubscribeLettageDone = this.props.subscribeToMore({
  //     document: LETTRAGE_DONE,
  //     variables: {
  //       companyId: this.props.companyId
  //     },

  //     updateQuery: (prev, { subscriptionData }) => {
  //       this.props.refetch();

  //       if (!subscriptionData.data) {
  //         return prev;
  //       }
  //       return prev;
  //     }
  //   });
  //   return;
  // }

  componentWillUnmount() {
    // this.unsubscribeEcritureLineCreated();
    // this.unsubscribeEcritureLineUpdated();
    // this.unsubscribeEcritureLineDeleted();
    // this.unsubscribeLettageDone();
  }

  render() {

    const edges = this.props.data && this.props.data.getReportSalesData;

    // TRANSLATIONS.....
    _.forEach(edges, o => {
      o.key = o.id;
      if (o.category && o.category.ids !== null) {
        // console.log("=>", o.node.category.ids);
        o.category.name = this.props.intl.formatMessage({
          id: o.category.ids
        });
      }

      if (
        o.category &&
        o.category.categoryFamily &&
        o.category.categoryFamily.ids !== null
      ) {
        o.category.categoryFamily.name = this.props.intl.formatMessage({
          id: o.category.categoryFamily.ids
        });
      }
    });

    console.log("242 - edges=", edges);

    return (
      <div>
        <ReportingChart
          {...this.props}
          edges={edges}
          negateValues={false}
          type="performance"
          showProductColumn={false}
          // tabs={["categories", "tiersAsSupplier", "project", "client"]}
          tabs={[
            "clientPerf"
            // , "projectPerf", "sellerPerf"
          ]}
          onRowClick={(row, state, rowInfo, column, instance) => {
            if (column.name === "period1" && rowInfo.original.p1Type && rowInfo.original.client) {
              // show side modal
              // console.log("251 - show side modal=", rowInfo.original);
              this.props.showSideModal &&
                this.props.showSideModal({
                  period: column.name,
                  type: rowInfo.original.p1Type,
                  id: rowInfo.original.client.id,
                  budgetProject: rowInfo.original.project || null
                });
            }

            if (column.name === "period2" && rowInfo.original.p2Type && rowInfo.original.client) {
              // show side modal
              // console.log("262 - show side modal=", rowInfo.original);
              this.props.showSideModal &&
                this.props.showSideModal({
                  period: column.name,
                  type: rowInfo.original.p2Type,
                  id: rowInfo.original.client.id,
                  budgetProject: rowInfo.original.project || null
                });
            }

            if (rowInfo.original.expenseId) {
              this.props.history.push(
                `/expenses/${rowInfo.original.expenseId}/edit`
              );
            }
            if (rowInfo.original.invoiceId) {
              this.props.history.push(
                `/invoices/${rowInfo.original.invoiceId}/edit`
              );
            }
            if (rowInfo.original.bankTransactionId) {
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransactionId}/affectation`
              );
            }
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(PerformanceReportChart));
